import { channels } from '@/mocks/channels';
import type { ChannelItem } from '@/pages/home/types';

const items: ChannelItem[] = channels;

const toneMap: Record<ChannelItem['tone'], { icon: string; badge: string }> = {
  primary: { icon: 'bg-primary-100 text-primary-700', badge: 'bg-primary-50 text-primary-700' },
  accent: { icon: 'bg-accent-100 text-accent-800', badge: 'bg-accent-50 text-accent-800' },
  secondary: { icon: 'bg-secondary-100 text-secondary-800', badge: 'bg-secondary-50 text-secondary-800' },
};

export default function Channels() {
  return (
    <section id="channels" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20 bg-background-100 border-y border-background-200">
      <div className="mb-8 md:mb-10 max-w-2xl">
        <span className="inline-flex items-center gap-1.5 text-xs font-bold text-primary-600 bg-primary-100 px-3 py-1.5 rounded-full mb-4">
          <i className="ri-layout-grid-line"></i> 爆料频道
        </span>
        <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug mb-3">
          六个常驻频道，覆盖娱乐圈与网红圈
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
          不同频道更新节奏不一样。想只看某个方向的内容，可以从上方吃瓜精选里按对应标签筛一筛。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {items.map((channel) => {
          const tone = toneMap[channel.tone];
          return (
            <div
              key={channel.id}
              className="flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between mb-4">
                <span className={`w-12 h-12 flex items-center justify-center rounded-lg ${tone.icon}`}>
                  <i className={`${channel.icon} text-2xl`}></i>
                </span>
                <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${tone.badge}`}>
                  {channel.count}
                </span>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">{channel.name}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{channel.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}